// Cole isso no seu constants.js, substituindo o REGIOES_BAIRROS atual

export const REGIOES_BAIRROS = {
  "Região Vale do Sol": [
    "Parque Residencial Vale do Sol",
    "Parque Igaçaba",
    "Jardim Águas do Paiol",
    "Jardim São Bento",
    "Jd. Sao Bento",
    "Jardim Residencial Elvio Lupo",
    "Jardim Residencial Lupo II",
    "Residencial Acapulco",
    "Jardim Nova Araraquara",
    "Jardim Botânico",
    "Residencial Cambuy",
    "Jardim Maria Luiza",
    "Jardim Maria Luiza II",
    "Jardim Maria Luiza III",
    "Jardim Maria Luiza IV",
    "Jardim Maria Luiza V",
    "Parque Residencial Damha",
    "Residencial Village Damha",
    "Residencial Village Damha II",
    "Residencial Village Damha III",
    "Jardim Universal",
    "Parque Laranjeiras",
    "Cidade Jardim",
    "Portal das Araucárias",
    "Jardim Residencial Paraíso",
    "Parque Planalto",
    "Jardim das Flores",
    "Altos do Jaraguá",
    "Condomínio Manoela",
    "Jardim dos Flamboyants",
    "Jardim Estância das Rosas",
    "Jardim Santa Rita de Cássia",
    "Jardim Tangará",
    "Residencial e Comercial Quinta das Laranjeiras",
    "Residencial Volpi",
    "Vila Aracoara",
    "Vila José Bonifácio",
  ],

  "Região Vila Xavier": [
    "Vila Xavier",
    "Jardim Brasil",
    "Jardim das Estações",
    "Jardim Paulistano",
    "Jardim América",
    "Parque São Paulo",
    "Jardim Pinheiros",
    "Jardim Santa Júlia",
    "Jardim Santa Júlia II",
    "Jardim Santa Júlia III",
    "Parque Gramado",
    "Parque Gramado II",
    "Residencial Alamedas",
    "Residencial Alamedas II",
    "Jardim Brasília",
    "Jardim Cristo Rei",
    "Jardim Europa",
    "Jardim Floridiana",
    "Jardim Morada do Sol",
    "Jardim Silvânia",
    "Jardim Tabapuã",
    "Jardim Viaduto",
    "Jardim Santa Clara",
    "Jardim Pinheiros II",
    "Vila Biagioni",
    "Vila Cidade Industrial",
    "Vila Esperança",
    "Vila Gaspar",
    "Vila Joinville",
    "Vila Popular",
    "Vila Renata",
    "Vila Santa Maria",
    "Vila Tito de Carvalho",
    "Vila Vieira",
    "Condomínio Parque dos Sabiás",
    "Jardim Altos de Pinheiros I e II",
    "Jardim Altos de Pinheiros III",
    "Jardim Ana Adelaide",
    "Jardim Esmeralda",
    "Jardim Jacarandá",
    "Jardim Martinez",
    "Jardim Nova Época",
    "Jardim Rosa Santa",
    "Parque Residencial Jatobá",
  ],

  "Região Centro": [
    "Centro",
    "São Geraldo",
    "Vila Santana",
    "Jardim Morumbi",
    "Jardim Quitandinha",
    "Jardim Quitandinha II",
    "Jardim Santa Lúcia",
    "Jardim Tamoio",
    "Jardim Nova América",
    "Jardim Santa Angelina",
    "Vila Yamada",
    "Jardim Dom Pedro I",
    "Vila do Servidor",
    "Vila Harmonia",
    "Fonte Luminosa",
    "Vila Velosa",
    "Campos Ville",
    "Central Park Morada do Sol",
    "Jardim Arangá",
    "Jardim Ártico",
    "Jardim Califórnia",
    "Jardim do Carmo",
    "Jardim dos Manacás",
    "Jardim Primavera",
    "Jardim Salto Grande",
    "Jardim Salto Grande IV",
    "Parque Alvorada",
    "Portal das Laranjeiras",
    "Quinta do Salto Residence",
    "Recreio Campestre Idanorma",
    "Residencial Ravena",
    "Residencial Tivoli",
    "Vila Bela Vista",
    "Vila DER",
    "Vila Ferroviária",
    "Vila Flórida",
    "Vila Furlan",
    "Vila Girassol",
    "Vila Higia", 
  ],

  "Região Norte": [
    "Jardim Roberto Selmi Dei",
    "Jardim Imperador",
    "Jardim Imperador II",
    "Vila Sedenho",
    "Jardim Adalberto Frederico de Oliveira Roxo I",
    "Parque Residencial Valle Verde",
    "Jardim Serra Azul",
    "Jardim São Rafael I",
    "Jardim São Rafael II",
    "Parque Residencial Jardim Ipanema",
    "Jardim Uirapuru",
    "Jardim Uirapuru II",
    "Condomínio Portal das Tipuanas",
    "Condomínio Quinta das Tipuanas",
    "Jardim das Acácias",
    "Jardim das Acácias II",
    "Condomínio Buona Vita",
    "Condomínio Vale das Rosas II",
    "Estrela e Kanashiro",
    "Jardim Aclimação",
    "Jardim Adalgisa",
    "Jardim Boa Vista",
    "Jardim Boa Vista II",
    "Jardim Boa Vista III",
    "Jardim Bounganville",
    "Jardim Celiamar",
    "Jardim do Bosque",
    "Jardim Gardênias",
    "Jardim Indaiá",
    "Jardim Magnólias",
    "Jardim Magnólias II",
    "Jardim Primor",
    "Jardim Residencial Maggiore",
    "Jardim Residencial Vale do Campo",
    "Jardim Tinen",
    "Jardim Vale das Rosas",
    "Jardim Veneza",
    "Jardim Zavanella",
    "Parque Residencial Jardim do Valle",
    "Parque Residencial Laura Molina",
    "Residencial Campos de Piemonte",
    "Residencial Monte Carlo",
    "Residencial Veredas do Campo",
    "Residencial Vista do Horto",
  ],

  "Região do Iguatemi": [
    "Vila Suconasa",
    "Parque Residencial Iguatemi",
    "Vila Melhado",
    "Jardim Cruzeiro do Sul I",
    "Jardim Cruzeiro do Sul II",
    "Parque Cecap",
    "Jardim Eliana",
    "Yolanda Opice",
    "Parque das Hortências",
    "Conjunto Habitacional Victório de Santi",
    "Jardim Victório Antônio de Santi II",
    "Jardim Del Rei",
    "Condomínio Satélite",
    "Doutor Tancredo de Almeida Neves",
    "Jardim Almeida",
    "Jardim Altos do Cecap I e II",
    "Jardim Araraquara",
    "Jardim Arco-Íris",
    "Jardim Athenas",
    "Jardim das Gaivotas",
    "Jardim Dumont",
    "Jardim Esplanada",
    "Jardim Florença",
    "Jardim Higienópolis",
    "Jardim Padre Anchieta",
    "Jardim Palmares",
    "Jardim Panorama",
    "Jardim Rafaela Amoroso Micelli",
    "Jardim Regina",
    "Jardim Residencial Água Branca",
    "Jardim Residencial Iedda",
    "Jardim Residencial Itália",
    "Jardim Residencial Quinta dos Oitis",
    "Jardim Residencial Silvestre",
    "Jardim Santa Marta",
    "Vila Guaianazes",
    "Residencial Portal dos Oitis",
  ],
};

export const CIDADE_COM_REGIAO = "Araraquara";

export function cidadeTemRegiao(cidade) {
  return (cidade || "").trim() === CIDADE_COM_REGIAO;
}

export function getRegiaoPorBairro(bairro, cidade) {
  if (!bairro || !cidadeTemRegiao(cidade)) return "";
  
  const normalizar = (str) =>
    str.toLowerCase().trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // remove acentos
      .replace(/ç/g, "c")              // ç → c
      .replace(/[^a-z0-9\s]/g, "")    // remove caracteres especiais restantes
      .replace(/\s+/g, " ");           // normaliza espaços

  const bairroNorm = normalizar(bairro);

  for (const [regiao, bairros] of Object.entries(REGIOES_BAIRROS)) {
    const found = bairros.find(b => normalizar(b) === bairroNorm);
    if (found) return regiao;
  }
  return "";
}

export const CIDADES = ["Araraquara", "Americo Brasiliense", "Santa Lucia", "Rincão", "Gavião Peixoto", "Matão", "São Carlos", "Boa Esperança do Sul", "Dobrada", 
  "Santa Ernestina", "Taquaritinga", "Ibaté", "Descalvado", "Ibitinga", "Motuca", "Nova Europa", "Tabatinga"];

export const REGIAO = Object.keys(REGIOES_BAIRROS);

export const REGIAO_COLORS = {
  "Região Vale do Sol": { bg: "rgba(59,130,246,0.15)", color: "#60a5fa" },
  "Região Vila Xavier": { bg: "rgba(34,197,94,0.15)", color: "#22c55e" },
  "Região Centro": { bg: "rgba(249,115,22,0.15)", color: "#f97316" },
  "Região Norte": { bg: "rgba(168,85,247,0.15)", color: "#c4a5fa" },
  "Região Sul": { bg: "rgba(234,179,8,0.15)", color: "#eab308" },
  "Sem região": { bg: "var(--s3)", color: "var(--muted)" },
};

export const API_URL = import.meta.env.VITE_API_URL
  || (import.meta.env.DEV ? '/api-proxy' : 'https://api.rotaflex.vhpsolutions.com.br');
export const TEMPO_INATIVIDADE = 30 * 60 * 1000;
export const INTERVALO_RENOVACAO_SESSAO = 60 * 1000;
export const ATIVIDADE_RECENTE_PARA_RENOVACAO = 90 * 1000;

export const css = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  .fade-in { animation: fadeIn 0.3s ease; }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes spin { to { transform: rotate(360deg); } }
  .spin { animation: spin 0.8s linear infinite; }
`;
